export default __webpack_public_path__ + "static/media/somwarpet.ae48dd6f.jpg";